import { FC, ReactNode } from 'react';

import { Dialog } from '@headlessui/react';

export interface ISlideOverHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
}

export const SlideOverHeader: FC<ISlideOverHeaderProps> = ({ icon, title, subtitle }) => {
  return (
    <div className='px-4 pt-8 pb-4 md:px-16 md:pt-16 md:pb-12'>
      <div className='flex flex-col items-center gap-4 text-center'>
        <div className='w-16 h-16 rounded-lg flex items-center justify-center'>{icon}</div>
        <div>
          <Dialog.Title className='text-2xl font-bold text-gray-900 uppercase tracking-wide mb-2'>{title}</Dialog.Title>
          {subtitle && <Dialog.Description className='text-base text-quaternary-400 font-semibold'>{subtitle}</Dialog.Description>}
        </div>
      </div>
    </div>
  );
};
